import axios from "axios";
import { showAlert } from "@/plugins/alertDialog";
export default {
  namespaced: true,
  state: {
    import_batches: [],
  },
  getters: {
    import_batches(state) {
      return state.import_batches;
    },
  },
  mutations: {
    SET_IMPORT_BATCHES(state, import_batches) {
      state.import_batches = import_batches;
    },
    ADD_IMPORT_BATCH(state, import_batch) {
      state.import_batches.unshift(import_batch);
    },
    EDIT_IMPORT_BATCH(state, import_batch) {
      var index = state.import_batches.findIndex(
        (a) => a.id == import_batch.id
      );
      if (index !== -1) {
        state.import_batches.splice(index, 1, import_batch);
      }
    },
  },
  actions: {
    async get_import_batches({ commit }) {
      let response = await axios.get("/import_batches");
      commit("SET_IMPORT_BATCHES", response.data);
    },
    // Preview the next batch tag for a supplier (PREFIX-SEQUENCE-BRANCHLETTER).
    // Returns the response data ({ batch_tag, sequence, branch_letter }). (JMB-18)
    async get_next_batch_tag(_, supplierId) {
      let response = await axios.get(`/supplier/${supplierId}/next_batch_tag`);
      return response.data;
    },
    async add_import_batch({ commit }, request) {
      try {
        const res = await axios.post("/import_batch", request);
        commit("ADD_IMPORT_BATCH", res.data);
        showAlert({
          title: "Success",
          message: "Successfully added a new batch",
          color: "success",
          icon: "mdi-check-circle",
        });
        return res.data;
      } catch (err) {
        showAlert({
          title: "Error",
          message: err.response?.data?.error || "Failed to add batch",
          color: "error",
          icon: "mdi-alert-circle",
        });
        throw err;
      }
    },
    async edit_import_batch({ commit }, request) {
      try {
        let response = await axios.put("/import_batch", request);
        commit("EDIT_IMPORT_BATCH", response.data);
        return response.data;
      } catch (err) {
        showAlert({
          title: "Error",
          message: err.response?.data?.error || "Failed to edit batch",
          color: "error",
          icon: "mdi-alert-circle",
        });
        throw err;
      }
    },
    async add_stock({ commit }, request) {
      let response = await axios.post("/add_stock", request);
      commit("EDIT_IMPORT_BATCH", response.data);
    },
  },
};
